import React from "react";
import { Icon } from "@iconify/react";
import spokeIcon from "../../../assets/icons/Spoke.svg";

const CenterTypeIcon = ({
  type,
  size = 15,
  color = "var(--app-text)",
}) => {
  if (!type) return null;

  const normalizedType = type.toLowerCase();

  // Custom icon for spoke
  if (normalizedType === "spoke") {
    return (
      <img
        src={spokeIcon}
        alt="spoke"
        width={size}
        height={size}
        style={{ objectFit: "contain" }}
      />
    );
  }

  // Iconify icons for others
  const iconMap = {
    hub: "mingcute:hospital-fill",
  };

  const iconName = iconMap[normalizedType];

  if (!iconName) return null;

  return (
    <Icon
      icon={iconName}
      width={size}
      height={size}
      style={{ color }}
    />
  );
};

export default CenterTypeIcon;